export const SimpleOfferIcon = (): JSX.Element => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.4 0C4.70261 0 3.07475 0.674284 1.87452 1.87452C0.674284 3.07475 0 4.70261 0 6.4L0 9.6C0 11.2974 0.674284 12.9253 1.87452 14.1255C3.07475 15.3257 4.70261 16 6.4 16H9.6C11.2974 16 12.9253 15.3257 14.1255 14.1255C15.3257 12.9253 16 11.2974 16 9.6V6.4C16 4.70261 15.3257 3.07475 14.1255 1.87452C12.9253 0.674284 11.2974 0 9.6 0L6.4 0ZM6.18 5.688L8 2L9.82 5.688L13.888 6.28L10.944 9.15L11.64 13.2L8 11.288L4.36 13.2L5.056 9.15L2.112 6.276L6.18 5.688Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>
	</svg>
)

export const StudentLoanRefinanceIcon = (): JSX.Element => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M8.79767 8.31833C8.27933 8.56033 7.72067 8.56033 7.20233 8.31833L1.16667 5.5L7.20233 2.68167C7.72067 2.43967 8.27933 2.43967 8.79767 2.68167L14.8333 5.5L8.79767 8.31833Z"
			stroke="currentColor"
			strokeWidth="1.2"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M11.8333 7.16667C11.8333 7.16667 12.1667 8.50001 12.1667 9.66667C12.1667 10.8333 11.9857 11.8333 11.9857 11.8333C8.7742 13.5667 5.33333 12.5556 4.01433 11.8333C4.01433 11.8333 3.83333 10.8333 3.83333 9.66667C3.83333 8.50001 4.16667 7.16667 4.16667 7.16667"
			stroke="currentColor"
			strokeWidth="1.2"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M14.8207 11.3577L14.8333 5.5"
			stroke="currentColor"
			strokeWidth="1.2"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M14.8333 12.657C15.2936 12.657 15.6667 12.2839 15.6667 11.8237C15.6667 11.3634 15.2936 10.9903 14.8333 10.9903C14.3731 10.9903 14 11.3634 14 11.8237C14 12.2839 14.3731 12.657 14.8333 12.657Z"
			stroke="currentColor"
		/>
	</svg>
)

export const LineOfCreditIcon = (): JSX.Element => (
	<svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.767 8.338v-4.01a.999.999 0 0 0 .895-.895h8.676a.999.999 0 0 0 .895.895v4.01a.999.999 0 0 0-.895.895H3.662a.999.999 0 0 0-.895-.895zM1.567 3.5c0-.7.567-1.267 1.266-1.267h10.334c.7 0 1.266.567 1.266 1.267v5.667c0 .7-.567 1.266-1.266 1.266H2.833c-.7 0-1.266-.567-1.266-1.266V3.5zM12 7a.667.667 0 1 0 0-1.333A.667.667 0 0 0 12 7zm-7.333-.667a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0zm2.433 0c0-.799.51-1.233.9-1.233s.9.434.9 1.233c0 .8-.51 1.234-.9 1.234s-.9-.434-.9-1.234zM8 3.9c-1.267 0-2.1 1.208-2.1 2.433 0 1.226.833 2.434 2.1 2.434 1.267 0 2.1-1.208 2.1-2.434C10.1 5.108 9.267 3.9 8 3.9zm-6.433 7.6a.6.6 0 0 1 .6-.6h11.666a.6.6 0 1 1 0 1.2H2.167a.6.6 0 0 1-.6-.6zm.6 1.067a.6.6 0 1 0 0 1.2h11.666a.6.6 0 0 0 0-1.2H2.167z"
			fill="currentColor"
		/>
	</svg>
)

export const LoanIcon = (): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
		<path fill="none" d="M0 0H20V20H0z" />
		<path
			fill="currentColor"
			d="M14.072 2a2.536 2.536 0 0 0-1.906.952h-2.141a.714.714 0 0 0-.669.965L10.6 7.236c-1.372 1.1-5.743 5.011-5.547 10.419A4.529 4.529 0 0 0 9.575 22h8.994a4.529 4.529 0 0 0 4.522-4.345c.2-5.408-4.175-9.323-5.547-10.419l1.244-3.318a.714.714 0 0 0-.669-.965h-2.141A2.536 2.536 0 0 0 14.072 2zm0 1.429a1.173 1.173 0 0 1 1.023.6.714.714 0 0 0 .618.355h1.376L16.2 6.762h-4.252l-.893-2.381h1.376a.714.714 0 0 0 .618-.355 1.173 1.173 0 0 1 1.023-.597zM11.7 8.19h4.747c.825.648 5.4 4.468 5.218 9.412a3.083 3.083 0 0 1-3.094 2.969H9.575A3.083 3.083 0 0 1 6.481 17.6C6.3 12.658 10.874 8.839 11.7 8.19zm2.362 1.418a.714.714 0 0 0-.7.725v.346a2.251 2.251 0 0 0-1.667 2.146 2.28 2.28 0 0 0 2.266 2.275h.7a.84.84 0 0 1 .007 1.681l-.876.007a.666.666 0 0 1-.64-.469.714.714 0 1 0-1.363.429 2.051 2.051 0 0 0 1.57 1.325v.36a.714.714 0 1 0 1.429 0v-.246a2.259 2.259 0 0 0-.126-4.515h-.7a.831.831 0 0 1-.841-.841.831.831 0 0 1 .829-.841l.392-.006a.667.667 0 0 1 .642.473.714.714 0 1 0 1.366-.418 2.049 2.049 0 0 0-1.563-1.339v-.366a.714.714 0 0 0-.725-.725z"
			transform="translate(-4.19 -2)"
		/>
	</svg>
)

export const SecuredLoanIcon = (): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" id="icons-secured-loan" width="20" height="20" viewBox="0 0 20 20">
		<path id="Rectangle_4687" fill="none" d="M0 0H20V20H0z" />
		<path
			id="Path_16521"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.5px"
			d="M7 9V5.89A4.046 4.046 0 0 1 11.186 2a4.046 4.046 0 0 1 4.186 3.89V9"
			transform="translate(-1.407 -.829)"
		/>
		<g id="Path_16539" fill="none" stroke="none">
			<path d="M7 0a7 7 0 1 1-7 7 7 7 0 0 1 7-7z" transform="translate(3 6)" />
			<path
				fill="currentColor"
				d="M7 1.5C3.967 1.5 1.5 3.967 1.5 7s2.467 5.5 5.5 5.5 5.5-2.467 5.5-5.5S10.033 1.5 7 1.5M7 0c3.866 0 7 3.134 7 7s-3.134 7-7 7-7-3.134-7-7 3.134-7 7-7z"
				transform="translate(3 6)"
			/>
		</g>
		<path
			id="Path_16537"
			d="M1.5 0A1.5 1.5 0 1 1 0 1.5 1.5 1.5 0 0 1 1.5 0z"
			fill="currentColor"
			transform="translate(8.5 11)"
		/>
		<path
			id="Path_16538"
			d="M.5 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 .5 0z"
			fill="currentColor"
			transform="translate(9.5 13)"
		/>
	</svg>
)

export const EmptySVG = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
		<path fill="none" d="M0 0H20V20H0z" />
	</svg>
)

export const PreApprovedIcon = () => (
	<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.4 0C4.70261 0 3.07475 0.674284 1.87452 1.87452C0.674284 3.07475 0 4.70261 0 6.4L0 9.6C0 11.2974 0.674284 12.9253 1.87452 14.1255C3.07475 15.3257 4.70261 16 6.4 16H9.6C11.2974 16 12.9253 15.3257 14.1255 14.1255C15.3257 12.9253 16 11.2974 16 9.6V6.4C16 4.70261 15.3257 3.07475 14.1255 1.87452C12.9253 0.674284 11.2974 0 9.6 0L6.4 0ZM3.1745 3.2H5.1L5.5075 3.85L7.0665 6.5705C6.30679 6.75229 5.62071 7.16171 5.1 7.744L2.5435 3.444C2.52849 3.41966 2.52027 3.39175 2.5197 3.36316C2.51914 3.33457 2.52624 3.30636 2.54028 3.28144C2.55432 3.25653 2.57478 3.23584 2.59952 3.22152C2.62427 3.20719 2.65241 3.19976 2.681 3.2H3.1745ZM11.254 10.383C11.2528 10.9558 11.101 11.5183 10.8138 12.014C10.5266 12.5096 10.1141 12.921 9.61772 13.2069C9.12131 13.4928 8.55845 13.6431 7.9856 13.6428C7.41276 13.6424 6.85007 13.4915 6.354 13.205C5.6041 12.77 5.0577 12.055 4.835 11.2172C4.6123 10.3794 4.73154 9.4874 5.1665 8.7375C5.60146 7.9876 6.31649 7.4412 7.15431 7.2185C7.99213 6.9958 8.8841 7.11505 9.634 7.55C10.1289 7.83436 10.5387 8.24592 10.821 8.742C11.1087 9.24076 11.2582 9.80723 11.254 10.383ZM13.454 3.442C13.4685 3.41771 13.4763 3.39 13.4766 3.36171C13.4769 3.33342 13.4697 3.30556 13.4557 3.28096C13.4417 3.25636 13.4215 3.23591 13.397 3.22169C13.3726 3.20746 13.3448 3.19998 13.3165 3.2H10.8745L10.4795 3.85L8.9205 6.5705C9.67996 6.75174 10.366 7.16044 10.887 7.742L13.454 3.442Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>
	</svg>
)
